var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.inMaintenanceMode)?_c('MaintenanceView'):_c('I18nInitializer',[(_vm.currentOverlay)?_c(_vm.currentOverlay,{tag:"component",attrs:{"overlaydata":_vm.currentOverlayData}}):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }